module.exports = __webpack_public_path__ + "media/images/the-information-logo-light-652e462e.svg";